import React from 'react';

import { cn } from '../../lib/utils';

import { useModalChrome } from './Modal';

const ModalTitle = ({ children, className, ...props }) => {
  const { showClose, closePlacement } = useModalChrome();
  const closePadding = showClose && (closePlacement === 'top-left' ? 'pl-5' : 'pr-5');

  return (
    <h2 className={cn('truncate text-2xl font-semibold text-black dark:text-neutral-200', closePadding, className)} {...props}>
      {children}
    </h2>
  );
};

export { ModalTitle };
